/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogRouteConfig, TextMessageDialogBaseComponent } from '@gh/core-ui';

@Component({
  standalone: false,
  selector: 'gh-text-message-dialog',
  templateUrl: 'text-message-dialog.component.html',
  styleUrls: ['text-message-dialog.component.scss'],
})
export class TextMessageDialogComponent<A> extends TextMessageDialogBaseComponent<A> {
  constructor(dialogRef: MatDialogRef<any>) {
    super(dialogRef);
  }
}

export const textMessageDialogRoute: DialogRouteConfig<TextMessageDialogComponent<any>> = {
  component: TextMessageDialogComponent,
  config: { minWidth: '300px', minHeight: '200px' },
};
